(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.VoltturiCore = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  function offer(config, index, subscribed) {
    const variant = config.offers[index];
    if (!variant || !variant.id) return { error: 'pack_missing', available: false, price: null };
    const plan = config.sellingPlanId
      ? (variant.plans || []).find(p => String(p.id) === String(config.sellingPlanId))
      : (variant.plans || [])[0];
    const active = subscribed ? plan : null;
    const price = active ? active.price : variant.price;
    const compare = variant.compare > price ? variant.compare : 0;
    return {
      id: variant.id, bottles: variant.bottles, quantity: variant.quantity || 1, paid: variant.paid || 1, free: variant.free || 0, price, compare,
      basePrice: variant.price, plan: active || null, subscriptionPlan: plan || null,
      available: !!variant.available,
      error: !variant.available ? 'sold' : ((subscribed && !plan) || (!subscribed && variant.requiresPlan)) ? 'plan_missing' : null,
      saving: compare ? Math.round((compare - price) / compare * 100) : 0
    };
  }
  function payload(config, index, subscribed) {
    const current = offer(config, index, subscribed);
    if (current.error) throw new Error(current.error);
    // The single product is added with all physical units, including the free ones.
    // Native Shopify Buy X Get Y discounts determine the actual cart/checkout total.
    const item = { id: current.id, quantity: current.quantity };
    if (current.plan) item.selling_plan = current.plan.id;
    return { items: [item] };
  }
  function money(cents, currency, language) {
    if (cents == null || !Number.isFinite(Number(cents))) return '—';
    return new Intl.NumberFormat({ja:'ja-JP',es:'es-ES',en:'en-US'}[language] || 'ja-JP', {
      style:'currency', currency, currencyDisplay:'narrowSymbol'
    }).format(Number(cents) / 100);
  }
  function discountMissing(config, cart) {
    const variant = config.offers[0];
    if (!config.quantityOffers || !variant?.id) return false;
    const groups = new Map();
    for (const item of cart.items) {
      if (String(item.variant_id || item.id) !== String(variant.id)) continue;
      const planId = item.selling_plan_allocation?.selling_plan?.id || '';
      const unit = planId ? (variant.plans || []).find(p => String(p.id) === String(planId))?.price : variant.price;
      if (unit == null) continue;
      const group = groups.get(planId) || {quantity:0,total:0,unit};
      group.quantity += item.quantity; group.total += item.final_line_price;
      groups.set(planId, group);
    }
    return Array.from(groups.values()).some(({quantity,total,unit}) => {
      const free = Math.max(Math.floor(quantity / 3), 2 * Math.floor(quantity / 5));
      return free > 0 && total > Math.round(unit * (quantity - free)) + 1;
    });
  }
  return { offer, payload, money, discountMissing };
});
